import React from 'react'
import moment from "moment";
import { getFormattedDate } from '../../../_helpers/_utils/utils';

export default function CreatedAt({ date }) {
    return (
        <p className="text-center">{getFormattedDate(date)} </p>
    )
}
